import React from 'react';
import { useNavigate } from 'react-router';
import PropTypes from 'prop-types';
import { Link } from '@uhg-abyss/web/ui/Link';
import { styled } from '@uhg-abyss/web/tools/styled';

const StyledLastLink = styled('div', {
  display: 'inline-block',
  padding: '0px 5px',
});

export const Breadcrumb = ({ id, route, label, isLast, onClick }) => {
  const isUrlHome = route === '/';
  const navigate = useNavigate();

  const navigateToHome = () => {
    window.location.hash = '#/';
  };
  return isLast ? (
    <StyledLastLink id={id || label.replace(' ', '-')}>{label}</StyledLastLink>
  ) : (
    <React.Fragment>
      <Link
        href={isUrlHome ? '' : route}
        isDisabled={isLast}
        onClick={isUrlHome ? navigateToHome : onClick}
      >
        {label}
      </Link>
    </React.Fragment>
  );
};

Breadcrumb.propTypes = {
  id: PropTypes.string,
  route: PropTypes.string,
  label: PropTypes.string.isRequired,
  isLast: PropTypes.bool.isRequired,
  customLink: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.node]),
  onClick: PropTypes.func,
};

Breadcrumb.defaultProps = {
  id: null,
  route: null,
  customLink: null,
  onClick: () => null,
};
